import { useAppSelector } from 'hooks/useRedux';
import { workflowSelectors } from 'state/workflow';
import ErrorComponent from 'components/ErrorComponent/ErrorComponent';
import {
  ERROR_EPCS_INVITE_FAILED,
  ERROR_INVALID_EPCS,
  ERROR_EPCS_IDP_FAILED,
} from 'constants/errorCodes';
import ColoredLine from 'components/ColoredLine/ColoredLine';

interface FormWrapperProps {
  children?: React.ReactNode;
  text?: string;
  disableError?: boolean;
  disableReturn?: boolean;
  customError?: string;
  errorSubTitle?: string;
  disableButton?: boolean;
}

const errorCodes = [ERROR_EPCS_INVITE_FAILED, ERROR_INVALID_EPCS, ERROR_EPCS_IDP_FAILED];

const FormWrapper = ({
  customError,
  children,
  text = '',
  disableError = false,
  disableReturn,
  errorSubTitle,
  disableButton,
}: FormWrapperProps) => {
  const error = useAppSelector(workflowSelectors.errorSelector);
  const errorCode = !Array.isArray(error) && typeof error === 'object' && error?.code;

  const setDisableButton = disableButton || (errorCode ? errorCodes.includes(errorCode) : false);

  return (
    <>
      <div className="mb-3">
        <div className={'fw-bolder h2 mt-4 mb-3'}>{text}</div>
        <ColoredLine />
      </div>
      {error && !disableError ? (
        <ErrorComponent
          disableButton={setDisableButton}
          customError={customError}
          disableReturn={disableReturn}
          errorSubTitle={errorSubTitle}
        />
      ) : (
        children
      )}
    </>
  );
};

export default FormWrapper;
